export default __webpack_public_path__ + "src/images/packages/zannier-hotels-sonop/5f81a1a73f33575532913f7e72c5346e-2.jpg";